export default function (config) {
  var qs = []
  for (var key in config) qs.push(`${key}=${config[key]}`)
  return qs.join("&")
}
